import { EuiFlexGroup, EuiFlexItem, EuiLoadingSpinner, EuiPanel, EuiText } from '@elastic/eui';
import React, { useMemo } from 'react';

interface Props{
    isLoading?:Boolean;
    text?:string;
}

export const MaskLoad = (props:Props) =>{

const {isLoading,text} = props;

const textRender = useMemo(()=>text!==undefined ? text : `Realizando operación....`,[text])

return (isLoading!==undefined && isLoading === true) ?(<div className='maskLoad'>
      <EuiPanel className='panel-spinner' grow={false} paddingSize='s'>
      <EuiFlexGroup direction='column'  justifyContent='center' gutterSize='none'>
        <EuiFlexItem >
           <img
            src="/spinner_custom.png"
            alt="Logo"
            className="bounce-spinner"
          />
          {/* <EuiLoadingSpinner size="xl"/> */}
        </EuiFlexItem>
        <EuiFlexItem grow={false}>
        <EuiText className="text-shine" textAlign='center' size='m'>{textRender}</EuiText>
        </EuiFlexItem>
        </EuiFlexGroup>
      </EuiPanel>
    </div>):null
}